//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import TodoRc from './list';
import TodoRcView from './view';

export const FilterScheduleTodoRC = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[2] !== "schedule_todo_rc") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterScheduleTodoRC.Provider value={{ filter, setFilter }}>
      <Route path="/schedule/schedule_todo_rc" exact component={TodoRc} isPrivate/>
      <Route path="/schedule/schedule_todo_rc/view/:id" exact component={TodoRcView} isPrivate/>
    </FilterScheduleTodoRC.Provider>
  )
}